import { Link } from 'react-router-dom';
import type { WorkshopDto } from '@workshop-hst/shared';
import { dateParts, relativeFromNow } from '../lib/format';
import { Tag } from './Tag';
import { Avatar } from './Avatar';
import { GuestRow } from './GuestBadge';

export function PastListItem({ workshop }: { workshop: WorkshopDto }) {
  const { day, month } = dateParts(workshop.startsAt);
  return (
    <Link
      to={`/w/${workshop.slug}`}
      className="group flex items-center gap-5 rounded-2xl border border-line bg-surface p-3 shadow-card transition hover:shadow-cardHover"
    >
      <div className="date-rail w-14 shrink-0">
        <span className="text-[10px] font-semibold uppercase tracking-wider text-ink-subtle">{month}</span>
        <span className="text-lg font-bold leading-none">{day}</span>
      </div>

      <div className="relative h-16 w-24 shrink-0 overflow-hidden rounded-xl bg-canvas">
        {workshop.coverImageUrl ? (
          <img
            src={workshop.coverImageUrl}
            alt=""
            loading="lazy"
            className="h-full w-full object-cover transition group-hover:scale-[1.03]"
          />
        ) : null}
      </div>

      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 text-xs text-ink-subtle">
          <span>{relativeFromNow(workshop.startsAt)}</span>
          <span className="h-1 w-1 rounded-full bg-line-strong" />
          <span>{workshop.durationMin} min</span>
        </div>
        <p className="mt-1 truncate text-[15px] font-semibold tracking-tight">{workshop.title}</p>
        <div className="mt-1 flex flex-wrap items-center gap-2 text-xs text-ink-muted">
          <span className="inline-flex items-center gap-1.5">
            <Avatar name={workshop.hostName} url={workshop.hostHeadshotUrl} size={18} />
            <span>{workshop.hostName}</span>
          </span>
          {workshop.guest ? <GuestRow guest={workshop.guest} size="sm" /> : null}
          {workshop.tags[0] ? <Tag>{workshop.tags[0]}</Tag> : null}
        </div>
      </div>

      <div className="shrink-0 pr-2">
        {workshop.recordingAvailable ? (
          <span className="inline-flex items-center gap-1.5 rounded-full border border-line bg-canvas px-3 py-1.5 text-xs font-semibold text-ink transition group-hover:bg-ink group-hover:text-white group-hover:border-ink">
            <svg width="10" height="10" viewBox="0 0 10 10" fill="currentColor" aria-hidden>
              <path d="M0 0v10l10-5L0 0z" />
            </svg>
            Watch
          </span>
        ) : (
          <span className="text-xs text-ink-subtle">No recording</span>
        )}
      </div>
    </Link>
  );
}
